const Config = {
  'algolia': {
  	'app_id': '6E1NSXNTTH',
  	'app_key': 'd4ceccfb371537bb6eab4cebd7f33f98'
  }
}

export default Config
